import type { components } from "@/api-schema";
import { VehicleIdentifierSystem } from "@/api-schema-enums";

type VehicleWithIdentifiers = Pick<components["schemas"]["Vehicle"], "vehicleIdentifiers">;

export function getVehicleV1Identifier(vehicle: VehicleWithIdentifiers): string | undefined {
  return vehicle.vehicleIdentifiers?.find((identifier) => identifier.type === VehicleIdentifierSystem.V1AhgGewa)
    ?.identifier;
}
